import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=72fef2ae&scoped=true"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"
import style0 from "./apply.vue?vue&type=style&index=0&id=72fef2ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fef2ae",
  null
  
)

export default component.exports